import { createProjectRetrospective, deleteCommentProjectRetrospective, editCommentProjectRetrospective, getCommentsProject, putHasCommentProject, sendEmailCommentProjectRetrospective } from "../../../../config"
import { percentValue } from "../../../../helpers/operationMath"
import { trimSpaces } from "../../../../helpers/textTransform"
import { MessageAnt } from "../../../../redux/slices/ui/uiAction"
import { MessageType } from "../../../../types/messageType"

const areaOptions = [
    { name: "Operaciones", value: 0, id: "operaciones" },
    { name: "Administración", value: 0, id: "administracion" },
    { name: "Finanzas", value: 0, id: "finanzas" },
    { name: "Comercial", value: 0, id: "comercial" },
    { name: "Marketing", value: 0, id: "marketing" },
    { name: "Arte 3D", value: 0, id: "arte3d" },
    { name: "Diseño UX/UI", value: 0, id: "diseno" },
    { name: "Programación Unity", value: 0, id: "unity" },
    { name: "Programación Web", value: 0, id: "web" },
    { name: "Proveedores", value: 0, id: "proveedores" },
    { name: "Sistemas", value: 0, id: "sistemas" },
]

const quotationsOptions = [
    { name: "Planeación", value: 0, id: "planeacion" },
    { name: "Desarrollo", value: 0, id: "desarrollo" },
    { name: "Viáticos", value: 0, id: "viaticos" },
]


const getFormList = (comments = []) => {
    return comments.reduce((prev, { category, comment, subCategory = [], _id }) => {

        if (!prev[category]) return { ...prev, [category]: [{ _id, comment, reason: subCategory }] }

        const data = [...prev[category], { _id, comment, reason: subCategory }]

        return { ...prev, [category]: data }
    }, {})
}

const getForm = (comments = []) => {

    if (comments.length === 0) return {
        analisis: [],
        comentarios: [],
        cotizacion: []
    }

    let formData = getFormList(comments);

    formData = {
        analisis: formData["analisis"] || [],
        comentarios: formData["comentarios"] || [],
        cotizacion: formData["cotizacion"] || []
    };

    return formData
}

const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const getTableByTags = ({ tags = [], tagsByProyect = [], totalHrs = 0 }) => {
    return tags
        .sort((a, b) => a.value - b.value)
        .reduce((prev, { name, color }) => {
            const findTagOnProyect = tagsByProyect.find((projectTag) => trimSpaces(projectTag.tag) === trimSpaces(name))

            const nameCapitalize = capitalizeFirstLetter(name)

            if (!findTagOnProyect) return [...prev, { name: nameCapitalize, color, hrs: 0, percentage: 0 }]

            const percent = percentValue(totalHrs, findTagOnProyect.spentTime)

            return [...prev, { name: nameCapitalize, color, hrs: findTagOnProyect.spentTime, percentage: percent }]
        }, [])
}

const getOptions = (options = []) => {
    return options
        .sort((a, b) => a.value - b.value)
        .map(({ name, id }) => ({
            label: name,
            value: id,
            className: "text-[10px] md:text-[12px] flex items-center"
        }))
}

export const getCommentAndTags = async (id, totalHrs = 0) => {
    const { status, payload } = await getCommentsProject(id)
    if (status > 0) return null

    const { comments, evaluationTags, tagTimesComments } = payload

    const mapTag = evaluationTags.map((tag) => ({ ...tag, id: tag.name }))
    const analysisOptions = getOptions(mapTag)
    const commentsOptions = getOptions(areaOptions)
    const quotationOptions = getOptions(quotationsOptions)

    const tableData = getTableByTags({ tags: evaluationTags, tagsByProyect: tagTimesComments, totalHrs })

    const getCommentForm = getForm(comments)


    return {
        dataTable: {
            analysis: analysisOptions,
            comments: commentsOptions,
            quotation: quotationOptions,
            tableData,
            isEditForm: true,
        },
        formsData: getCommentForm
    }
}

export const setJsonBySave = ({ category, subCategorys = [] }) => {
    return subCategorys.reduce((prev, current) => {
        const dataId = current?._id || null
        const subCategory = current.reason.map((reason) => !reason?.label ? reason : reason.value)
        return [...prev, { _id: dataId, body: current.comment, category, subCategory }]
    }, [])
}

export const getCommentInformation = (comments = {}) => {
    return Object.values(comments).reduce((prev, current) => {
        return [...prev, ...current]
    }, [])
}


export const requestEndpoint = async ({ form }) => {

    const [{ status }] = await Promise.all([
        createProjectRetrospective(form),
        putHasCommentProject(form.spaceId)
    ])


    if (status > 1) {
        MessageAnt(MessageType.error, `Error al agregar el retrospective`);
        return false;
    }

    if (status === 1) {
        MessageAnt(MessageType.warning, `El email no se envio`);
    }


    return true
}


export const requestUpdateComment = async ({ form, hasComments = false }) => {
    let id = null
    try {
        let update = { status: 1 }

        if (hasComments) {
            update = await editCommentProjectRetrospective(form)
        } else {
            const [updateRetro] = await Promise.all([
                editCommentProjectRetrospective(form),
                putHasCommentProject(form.spaceId)
            ])
            update = updateRetro
        }

        if (update.status > 0) {
            MessageAnt(MessageType.error, !form.id ? "No se puedo crear" : `No se puedo actualizar comentarios`);
            return {
                ok: false,
                id
            }
        }

        id = update.payload.updateCommentData._id

    } catch (error) {
        MessageAnt(MessageType.error, `No se puedo actualizar comentarios`);
        return {
            ok: false,
            id
        }
    }

    return {
        ok: true,
        id
    }
}


export const requestDeleteComment = async (id) => {
    try {
        await deleteCommentProjectRetrospective(id)
    } catch (error) {
        MessageAnt(MessageType.error, `No se puedo eliminar comentarios`);
        return false
    }

    return true
}

const checkFieldArray = ({ fileds }) => {
    const arrayValidation = []

    let isExistDabase = false

    for (const field of fileds) {
        if (!field) {
            arrayValidation.push(true)
            continue
        }

        if (field?._id) {
            isExistDabase = true
            break
        }

        arrayValidation.push(field?.comment === "")
    }

    return {
        isNext: arrayValidation.every(v => v === true),
        isExistDabase
    }
}


export const checkQuotation = (fileds = []) => {

    const { isNext, isExistDabase } = checkFieldArray({ fileds })

    if (isExistDabase) {
        MessageAnt(MessageType.warning, "Existe referencia en la base elimina todos los comentarios antes de seleccionar 'Sí'");
        return { ok: false, code: 1 }
    }

    if (!isNext) {
        MessageAnt(MessageType.warning, "Elimina todos los comentarios antes de seleccionar 'Sí'");
    }

    return { ok: isNext, code: 0 }
}


export const getDataFormByKey = (form) => {
    const keyForm = Object.keys(form.getFieldsValue())[0];
    const formList = form.getFieldValue(keyForm);
    return {
        key: keyForm,
        data: formList
    }
}


export const editComment = async ({ project, form, idChild, auth }) => {
    const { clickupSpace, hasComments } = project;
    const { key, data } = getDataFormByKey(form);

    const newReason = setJsonBySave({ category: key, subCategorys: data });

    const { _id = null, body, subCategory } = newReason[idChild];
    const { ok: isUpdateCorrect, id } = await requestUpdateComment(
        {
            form: {
                id: _id,
                spaceId: clickupSpace,
                personName: auth.name,
                category: key,
                subCategory: subCategory,
                comment: body
            },
            hasComments
        }
    );

    let updateForm = [...data];
    updateForm[idChild]._id = id;

    form.setFieldsValue({ [key]: updateForm });


    return isUpdateCorrect
}

export const createComments = async ({ project, auth, isEditForm, commentByTabRef }) => {
    const { clickupSpace } = project;
    const wasUpdateSuccessful = await requestEndpoint({
        isEdit: isEditForm,
        form: {
            personName: auth.name,
            spaceId: clickupSpace,
            commentInformation: getCommentInformation(commentByTabRef)
        }
    });
    return {
        clickupSpace,
        wasUpdateSuccessful
    }
}

export const sendeEmailComment = async ({ project }) => {
    const { clickupSpace } = project;
    const { payload, status } = await sendEmailCommentProjectRetrospective(clickupSpace)
    if (status === 0) {
        MessageAnt(MessageType.success, "Correo enviado");
        return
    }
    MessageAnt(MessageType.warning, payload);
}